export default __webpack_public_path__ + "static/media/MenuBook.375a0c08.svg";